module.exports = __webpack_public_path__ + "static/img/8.b5cb42d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/sp/8.png
// module id = /Rsu
// module chunks = 0